import { render, staticRenderFns } from "./LKReportsDataCollectionsList.vue?vue&type=template&id=cf129610&scoped=true&"
import script from "./LKReportsDataCollectionsList.vue?vue&type=script&lang=js&"
export * from "./LKReportsDataCollectionsList.vue?vue&type=script&lang=js&"
import style0 from "./LKReportsDataCollectionsList.vue?vue&type=style&index=0&id=cf129610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf129610",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VSimpleTable})
